import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { AdministratorDTO } from 'src/app/shared/models/dtos/responses/administrator-dto/administrator-dto';

@Component({
  selector: 'app-admin-edit-data',
  templateUrl: './admin-edit-data.component.html',
  styleUrls: ['./admin-edit-data.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

/**
 * Shows basic infos about Global Admin
 */
export class AdminEditDataComponent implements OnInit {
  @Input() adminSummary?: AdministratorDTO;
  adminNameLength!: number;
  adminDataLabels = {
    globalAdmin: 'view-only',
    setAName: 'set-a-name',
  };
  @Input() adminDataFormGroup!: FormGroup;

  /**
   * Constructor
   */
  constructor(private translationService: TranslationService) {}

  /**
   * onInit()
   */
  ngOnInit() {
    this.translationService.translateObject(this.adminDataLabels);
  }

  /**
   * @param {string} controlName
   * @return {FormControl}
   */
  getControl(controlName: string): FormControl {
    return this.adminDataFormGroup.get(controlName) as FormControl;
  }

  /**
   * Checks if name length is too big
   * @return {boolean}
   */
  maxNameLength(): boolean {
    const maxLength = 18;
    if (!this.adminSummary) {
      return false;
    }
    return this.adminSummary.name.length >= maxLength ? true : false;
  }

  /**
   * save the new picture uploaded by the user
   * @param {string} imgUrl
   */
  saveNewImage(imgUrl: string) {
    if (imgUrl) {
      this.adminDataFormGroup.patchValue({ picture: imgUrl });
    }
  }
}
